import { IDecaDocument, IDecaDocumentSegment } from '@okcargo-apps/shared-domain';
import {
  CreateDigitalControlDocFromSegmentsAsCarrierCommand,
  CreateDigitalControlDocFromSegmentsAsShipperCommand,
  DigitalControlDocSegmentPayload,
  UpdateDigitalControlDocFromSegmentsAsCarrierCommand,
  UpdateDigitalControlDocFromSegmentsAsShipperCommand,
} from '@okcargo/command-processor';

export function transformFromIDecaDocumentToCreateAsShipperCommand(
  document: IDecaDocument,
): CreateDigitalControlDocFromSegmentsAsShipperCommand {
  return {
    id: document.id || crypto.randomUUID(),
    reference: document.reference,
    carrierName: document.carrier.companyName,
    carrierTaxId: document.carrier.taxId,
    carrierAddressStreet: document.carrier.street,
    carrierAddressPostalCode: document.carrier.postalCode,
    carrierAddressCity: document.carrier.city,
    carrierContactFirstName: document.carrier.contactFirstName ?? '',
    carrierContactLastName: document.carrier.contactLastName,
    carrierContactEmail: document.carrier.contactEmail,
    carrierContactPhone: document.carrier.contactPhone,
    carrierAddressStateCode: document.carrier.stateCode,
    carrierAddressCountryCode: document.carrier.countryCode,
    specialAuthorizationType: document.specialAuthorizationType || '',
    tractorPlateNumber: document.tractorPlateNumber,
    trailerPlateNumber: document.trailerPlateNumber,
    reservations: document.reservations,
    segments: transformFromIDecaDocumentSegmentToDigitalControlDocSegmentPayloadList(document.segments),
  };
}

export function transformFromIDecaDocumentToUpdateAsShipperCommand(
  document: IDecaDocument,
  changeReason = '',
): UpdateDigitalControlDocFromSegmentsAsShipperCommand {
  return {
    id: document.id,
    reference: document.reference,
    carrierName: document.carrier.companyName,
    carrierTaxId: document.carrier.taxId,
    carrierAddressStreet: document.carrier.street,
    carrierAddressPostalCode: document.carrier.postalCode,
    carrierAddressCity: document.carrier.city,
    carrierContactFirstName: document.carrier.contactFirstName ?? '',
    carrierContactLastName: document.carrier.contactLastName,
    carrierContactEmail: document.carrier.contactEmail,
    carrierContactPhone: document.carrier.contactPhone,
    carrierAddressStateCode: document.carrier.stateCode,
    carrierAddressCountryCode: document.carrier.countryCode,
    specialAuthorizationType: document.specialAuthorizationType || '',
    tractorPlateNumber: document.tractorPlateNumber,
    trailerPlateNumber: document.trailerPlateNumber,
    changeReason,
    // reservations: document.reservations,
    segments: transformFromIDecaDocumentSegmentToDigitalControlDocSegmentPayloadList(document.segments),
  };
}

// TODO review this
export function transformFromIDecaDocumentToCreateAsCarrierCommand(
  document: IDecaDocument,
): CreateDigitalControlDocFromSegmentsAsCarrierCommand {
  return {
    id: document.id || crypto.randomUUID(),
    reference: document.reference,
    shipperName: document.shipper.companyName ?? '',
    shipperTaxId: document.shipper.taxId ?? '',
    shipperAddressStreet: document.shipper.street ?? '',
    shipperAddressPostalCode: document.shipper.postalCode ?? '',
    shipperAddressCity: document.shipper.city ?? '',
    shipperContactFirstName: document.shipper.contactFirstName ?? '',
    shipperContactLastName: document.shipper.contactLastName ?? '',
    shipperContactEmail: document.shipper.contactEmail ?? '',
    shipperContactPhone: document.shipper.contactPhone ?? '',
    shipperAddressStateCode: document.shipper.stateCode ?? '',
    shipperAddressCountryCode: document.shipper.countryCode ?? '',
    specialAuthorizationType: document.specialAuthorizationType || '',
    tractorPlateNumber: document.tractorPlateNumber,
    trailerPlateNumber: document.trailerPlateNumber,
    reservations: document.reservations,
    segments: transformFromIDecaDocumentSegmentToDigitalControlDocSegmentPayloadList(document.segments),
  };
}

// TODO review this
export function transformFromIDecaDocumentToUpdateAsCarrierCommand(
  document: IDecaDocument,
  changeReason = '',
): UpdateDigitalControlDocFromSegmentsAsCarrierCommand {
  return {
    id: document.id,
    reference: document.reference,
    shipperName: document.shipper.companyName ?? '',
    shipperTaxId: document.shipper.taxId ?? '',
    shipperAddressStreet: document.shipper.street ?? '',
    shipperAddressPostalCode: document.shipper.postalCode ?? '',
    shipperAddressCity: document.shipper.city ?? '',
    shipperContactFirstName: document.shipper.contactFirstName ?? '',
    shipperContactLastName: document.shipper.contactLastName ?? '',
    shipperContactEmail: document.shipper.contactEmail ?? '',
    shipperContactPhone: document.shipper.contactPhone ?? '',
    shipperAddressStateCode: document.shipper.stateCode ?? '',
    shipperAddressCountryCode: document.shipper.countryCode ?? '',
    specialAuthorizationType: document.specialAuthorizationType || '',
    tractorPlateNumber: document.tractorPlateNumber,
    trailerPlateNumber: document.trailerPlateNumber,
    changeReason,
    // reservations: document.reservations,
    segments: transformFromIDecaDocumentSegmentToDigitalControlDocSegmentPayloadList(document.segments),
  };
}

function transformFromIDecaDocumentSegmentToDigitalControlDocSegmentPayload(
  segment: IDecaDocumentSegment,
): DigitalControlDocSegmentPayload {
  if (!segment.origin.date || !segment.destination.date) {
    throw new Error('Origin and destination dates are required to send the control document.');
  }

  return {
    id: segment.id || crypto.randomUUID(),
    origin: {
      companyName: segment.origin.companyName,
      street: segment.origin.street,
      city: segment.origin.city,
      date: new Date(segment.origin.date),
      postalCode: segment.origin.postalCode,
      stateCode: segment.origin.stateCode,
      countryCode: segment.origin.countryCode,
    },
    destination: {
      companyName: segment.destination.companyName,
      street: segment.destination.street,
      city: segment.destination.city,
      date: new Date(segment.destination.date),
      postalCode: segment.destination.postalCode,
      stateCode: segment.destination.stateCode,
      countryCode: segment.destination.countryCode,
    },
    goodsDescription: segment.goodsDescription,
    netWeight: segment.netWeight as number,
  };
}

function transformFromIDecaDocumentSegmentToDigitalControlDocSegmentPayloadList(
  dtos: IDecaDocumentSegment[],
): DigitalControlDocSegmentPayload[] {
  return (dtos ?? []).map((dto) => transformFromIDecaDocumentSegmentToDigitalControlDocSegmentPayload(dto));
}
